// Tableau pour stocker les éléments à surveiller
const stickyElements = [];

/**
 * Ajoute un élément à surveiller
 * @param {string} selector - Sélecteur CSS de l'élément
 * @param {number} top - Distance du haut de l'écran une fois fixé
 */
function addStickyElement(selector, top = 0) {
    const el = document.querySelector(selector);
    if (!el) return;

    const rect = el.getBoundingClientRect();
    const offsetTop = rect.top + window.scrollY; // position initiale dans la page
    const parent = el.parentNode;

    // Placeholder pour garder la place quand l'élément devient fixed
    const placeholder = document.createElement("div");
    placeholder.style.width = rect.width + "px";
    placeholder.style.height = rect.height + "px";
    placeholder.style.display = "none";
    parent.insertBefore(placeholder, el);

    stickyElements.push({ el, top, offsetTop, rect, placeholder, parent });
}

function handleScroll() {
    stickyElements.forEach((item) => {
        const parentRect = item.parent.getBoundingClientRect();
        const parentBottom = parentRect.bottom + window.scrollY;

        // Si on a scrollé assez pour "fixer"
        if (window.scrollY > item.offsetTop - item.top) {
            // Mais on ne dépasse pas le parent
            if (window.scrollY + item.el.offsetHeight + item.top < parentBottom) {
                item.el.style.position = "fixed";
                item.el.style.top = item.top + "px";
                item.el.style.left = item.rect.left + "px";
                item.el.style.width = item.rect.width + "px";
                item.placeholder.style.display = "block";
            } else {
                // Collé en bas du parent
                item.el.style.position = "absolute";
                item.el.style.top = (parentBottom - item.el.offsetHeight - item.offsetTop) + "px";
                item.el.style.left = "";
                item.el.style.width = "";
            }
        } else {
            // Retour état normal
            item.el.style.position = "";
            item.el.style.top = "";
            item.el.style.left = "";
            item.el.style.width = "";
            item.placeholder.style.display = "none";
        }
    });
}

// Écouteur global
window.addEventListener("scroll", handleScroll);
window.addEventListener("resize", () => {
    // recalculer si besoin
    stickyElements.forEach((item) => {
        const rect = item.el.getBoundingClientRect();
        item.rect = rect;
        item.offsetTop = rect.top + window.scrollY;
        item.placeholder.style.width = rect.width + "px";
        item.placeholder.style.height = rect.height + "px";
    });
});

// Exemple d’utilisation
addStickyElement("nav.filters", 70);
